






import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PublishedApp } from '../../shared/models';
import { googleBmApi } from '../services/googlebmApi';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import { AgentConfigRequest } from '@/features/apps/googlebm/models/agentConfigRequest';
import { GoogleBmAgent } from '../models/googleBmAgent';
import GoogleBmAgentConfig from './googleBmAgentConfig.vue';

@Component({
	components: { GoogleBmAgentConfig }
})
export default class GoogleBmEditAgent extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	@Prop() public agent: GoogleBmAgent | null;

	public actionInProgress: boolean = false;

	public async onSave(request: AgentConfigRequest) {
		if (this.actionInProgress) {
			return;
		}
		if (!this.agent) {
			return;
		}
		this.actionInProgress = true;

		try {
			await googleBmApi.updateAgent(this.currentWorkspace.id, this.agent.customAgentId, request);
			this.$emit('configSaved');
		} catch (err) {
			Toast.showError(`Failed to save agent : ${err.message}`);
		}
		this.actionInProgress = false;
	}

	public onCancel() {
		this.$emit('cancel');
	}
}
